<template>
  <div class="main-container" style="background: #f7f7f7">
    <div class="main-content-wrap" style="background: #f7f7f7">
      <div
        class="main-content-pannel flex flex-col main-content-pannel-t wrapper"
      >
        <div>
          <div>
            <div class="title">Payment</div>
          </div>
        </div>
        <div v-if="hasPayoutMethod">
          <div class="cards-wrapper">
            <div class="card-wrapper">
              <div class="card-top-wrapper">
                <img :src="accountLogo" class="card-logo" alt="bank logo" />
                <div>{{ accountName }} *{{ accountLast4 }}</div>
              </div>
              <div class="card-divider" />
              <div class="card-created">Created {{ accountCreated }}</div>
            </div>
          </div>
          <div class="table-wrapper">
            <div class="table-title">Payments</div>
            <ag-grid-vue
              style="width: 100%; height: 300px"
              class="ag-theme-material"
              :gridOptions="gridOptions"
              :columnDefs="columnDefs"
              @column-resized="onColumnResized"
              @first-data-rendered="onFirstDataRendered"
              @grid-size-changed="onFirstDataRendered"
              :rowData="rowData"
            ></ag-grid-vue>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import { httpGet } from "@/http/http";
import moment from "moment";
import * as utils from "@/utils/utils";

export default {
  data() {
    return {
      queryId: null,
      consultant: null,
      hasPayoutMethod: false,

      accountObject: null,
      accountName: null,
      accountLast4: null,
      accountCreated: null,
      accountLogo: null,

      gridOptions: {},
      columnDefs: null,
      rowData: null,
    };
  },
  components: {
    AgGridVue,
  },
  watch: {
    consultant: function () {
      this.initData();
    },
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    this.initColumnDefs();
    this.bindData();
  },
  methods: {
    initColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.columnDefs = [
        { headerName: "CREATED", field: "created" },
        { headerName: "AMOUNT", field: "amount" },
        { headerName: "DESCRIPTION", field: "description" },
        { headerName: "ID", field: "id" },
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    bindData: function () {
      if (this.queryId) {
        this.$bind(
          "consultant",
          db.collection("consultants").doc(this.queryId)
        );
      }
    },
    initData: function () {
      if (this.consultant.stripe_account || this.consultant.stripe_id) {
        if (this.consultant.stripe_account) {
          this.accountCreated = moment(
            this.consultant.stripe_account.created * 1000
          )
            .tz("America/Los_Angeles")
            .format("MM/YY");
          this.accountName = this.consultant.stripe_account.name;
          this.accountLast4 = this.consultant.stripe_account.last4;
          if (this.accountName) {
            this.accountLogo =
              "//logo.clearbit.com/" +
              this.accountName.replace(/\s/g, "") +
              ".com";
          } else {
            this.accountLogo = "@/assets/image/logo.png";
          }
          this.hasPayoutMethod = true;
        }
        if (this.consultant.stripe_id) {
          httpGet("get_transfer_by_stripe_id", {
            stripeId: this.consultant.stripe_id,
          }).then((response) => {
            if (response.ok) {
              const rowData = response.data;
              rowData.forEach((item) => {
                item.created = utils.dateformat(item.created);
                item.amount = utils.currencyFilter(item.amount / 100, "$", 2);
              });
              this.rowData = rowData;
            } else {
              this.rowData = [];
            }
          });
        }
      } else {
        this.$router
          .push("/home/no_consultant_payment_account")
          .catch((err) => {});
      }
    },
  },
};
</script>


<style scoped>
.wrapper {
  margin: 66px 44px;
  padding: 0;
}
.wrapper * {
  box-sizing: border-box;
}
.wrapper .ag-row {
  min-height: 64px !important;
}
.title {
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  color: #1c1c1c;
  font-family: inter-regular;
}
.payment-wrapper {
  display: flex;
  margin-top: 13px;
  flex-wrap: wrap;
}
.payment-wrapper > :not(:last-child) {
  margin-right: 18px;
}
.payment-item {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 16px;
  min-width: 264px;
  min-height: 108px;
}
.payment-item-header {
  display: flex;
  align-items: center;
}
.payment-item-header-img {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.payment-item-header-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1c1c1c;
  font-family: inter-regular;
}
.payment-item-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 12px 0 8px;
}
.payment-item-footer {
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: inter-regular;
  font-weight: 500;
}
.bankaccount-tag {
  display: flex;
  align-items: center;
  background: linear-gradient(
      0deg,
      rgba(255, 150, 27, 0.1),
      rgba(255, 150, 27, 0.1)
    ),
    #ffffff;
  border-radius: 6px;
  padding: 2px 6px;
  color: #f98600;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  font-family: inter-regular;
}
.card-tag {
  display: flex;
  align-items: center;
  background: linear-gradient(
      0deg,
      rgba(0, 133, 255, 0.1),
      rgba(0, 133, 255, 0.1)
    ),
    #ffffff;
  border-radius: 6px;
  padding: 2px 6px;
  color: #0085ff;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  font-family: inter-regular;
}
.tag-img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.payment-item-add {
  margin: 0;
  width: 264px;
}
.table-wrapper {
  margin-top: 25px;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  min-height: 358px;
}
.table-title {
  padding: 24px 24px 6px;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #1c1c1c;
  font-family: inter-regular;
}
.cards-wrapper {
  display: flex;
  margin-top: 24px;
}
.card-wrapper {
  min-width: 264px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}
.card-wrapper:not(:first-child) {
  margin-left: 16px;
}
.card-top-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  font-family: inter-regular;
}
.card-logo {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  height: 32px;
  margin-right: 8px;
}
.card-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 8px 0;
}
.card-created {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  font-family: inter-regular;
}
</style>

